import { useFeatureIsOn } from 'src/common/growthbook';
import { RoomTask } from 'src/common/interfaces/tasks';
import { useIsUserAuthenticated } from 'src/common/hooks/use-is-user-authenticated';

export const useLockedTasks = (isPublicRoom: boolean, tasks?: RoomTask[]) => {
  const isUserAuth = useIsUserAuthenticated();
  const isForceCompleteRoomsInOrderExperimentEnabled = useFeatureIsOn('force-complete-rooms-order');

  if (!isForceCompleteRoomsInOrderExperimentEnabled || !isUserAuth || !isPublicRoom) {
    return [];
  }
  const reverseSortedTasks = [...(tasks || [])]?.sort((task1, task2) => task2.taskNo - task1.taskNo);
  const highestCompletedTaskNo =
    reverseSortedTasks?.find((task) => task.questions.every((question) => !!question.progress?.correct))?.taskNo || 0;
  return reverseSortedTasks?.filter((task) => task.taskNo > highestCompletedTaskNo + 1);
};
